import numbro from 'numbro'

/**
 * Using numbro.js from {@link https://numbrojs.com/}
 */

numbro.registerLanguage({
  languageTag: 'es-ES',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'era'
  },
  currency: {
    symbol: ' EUR',
    position: 'postfix',
    code: 'EUR'
  },
  formats: {
    fourDigits: {
      totalLength: 4,
      spaceSeparated: true
    },
    fullWithTwoDecimals: {
      output: 'currency',
      thousandSeparated: true,
      mantissa: 2
    },
    fullWithTwoDecimalsNoCurrency: {
      thousandSeparated: true,
      mantissa: 2
    },
    fullWithNoDecimals: {
      output: 'currency',
      thousandSeparated: true,
      mantissa: 0
    }
  }
}, true)

numbro.setLanguage('es-ES')

export default numbro
